import 'bulma-pageloader/dist/css/bulma-pageloader.min.css'
import 'bulma/css/bulma.css'
import './App.css'

import { App as RealmApp, User, Credentials } from "realm-web"
import amplitude from 'amplitude-js'

import { NavBar, TAB } from './Layout/NavBar'
import { HeatMap } from './Heatmap'
import { Growth } from './Growth'
import { KPI } from './Kpis/kpis'

import { iData } from './Utils/Types'
//import newData from './newData.json'
//import debugData from './data.json'

import { Notification } from './Layout/Notification'
import React, { useState, useEffect } from 'react'
import { parseTweets } from './Utils/scripts'


const DEBUG = false
const Section = ({ children }: { children?: any }) => <div className="section" style={{padding:'1.5rem' }}>
    <div className="container"> {children} </div>
</div>


const App = () => {
    const [ tab, setTab ] = useState<TAB>('KPI')
    const [ oauthToken, setOauthToken ] = useState('')
    const [ data, setData ] = useState<iData|null>(null)
    const [ fetching, setFetching ] = useState(false)
    const [ authenticated, setAuthenticated ] = useState(false)

    useEffect(() => {
        const initTwitter = async(user: User) => {
            const mongo = user.mongoClient('myAtlasCluster')
            const db = mongo.db("Startup-Ideas")
            const collection = db.collection("Ideas")

            const doc: iData = await collection.findOne({ userName: 'SocialQui' })
            console.log('Doc: ', doc)
            setData(doc)

            const oauthToken = await user.functions.requestAccess()	
            setOauthToken(oauthToken)
        }

        const initDB = async (user: User, userId: string) => {
            const mongo = user.mongoClient('myAtlasCluster')
            const db = mongo.db("Startup-Ideas")
            const collection = db.collection("Ideas")

            const doc = await collection.findOne({ userId })
            console.log(doc)

            setData(doc)
            setAuthenticated(true)
        }

        const initAuth = async (search: string, user: User) => {
            try {
                setFetching(true)

                const tokens = search.replace('?oauth_token=', '').replace('oauth_verifier=', '').split('&')	
                const [oauth_token, oauth_verifier] = tokens
                const initMetricsBody = { oauth_token, oauth_verifier, user: user.id }
                const { tweets, userId, userName } = await user.functions.initMetrics(initMetricsBody)

                console.log('Data: ', tweets, userId, userName)
                window.localStorage.setItem('userId', userId)
                window.localStorage.setItem('userName', userName)

                const mongo = user.mongoClient('myAtlasCluster')
                const db = mongo.db("Startup-Ideas")
                const collection = db.collection("Ideas")
                const doc = await collection.findOne({ userName })

                if(doc) { setData(doc) } 
                else {
                    const loadData: iData = parseTweets({userName, userId, tweets})
                    setData(loadData)
                    await collection.insertOne(loadData)
                }

                setAuthenticated(true)
            } catch (e) { console.log('Error Authenticating: ', e) }
        }
        
        const initAmplitude = async () => {
            amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE_TOKEN as string)
            amplitude.getInstance().logEvent('VISIT_SCHEDULER')
        }        

        const startApp = async() => {
            const REALM_APP_ID = "tasktracker-kjrie"
            const app = new RealmApp({ id: REALM_APP_ID })
            const user: User = await app.logIn(Credentials.anonymous())
            const userId = window.localStorage.getItem('userId')

            const { search } = window.location
            const hasAuthorization = search && search.includes('oauth_token') && search.includes('oauth_verifier')

            if(userId) {
                initDB(user, userId as string)

            } else if(hasAuthorization) {
                initAuth(search, user)

            } else {
                initTwitter(user)
            }

            initAmplitude()
        }
/*
        const devApp = async() => {
                const loadData: iData = parseTweets({userName: 'SocialQui', userId: '', tweets: newData})
                setData(loadData)
                
            } else {
                //setData(debugData as unknown as iData)
            }
        }
*/
        if (!DEBUG){ startApp() }
//        else { devApp() } 
    }, [])


    return data
    ? 
        <div>
            <NavBar oauthToken={oauthToken} click={ t => setTab(t)} authenticated={authenticated} data={data} />
            <Section>
                { data.paying && !authenticated ? <Notification tab={tab} auth={authenticated}/> : null }
                { tab === 'KPI' ? <KPI data={data}/> : null }
                { tab === 'GROWTH' ? <Growth data={data}/> : null }
                { tab === 'HEATMAP' ? <HeatMap data={data}/> : null }
            </Section>
        </div>
    :
        <div className={`pageloader ${!data ? 'is-active' : '' } is-black`}>
            <span className="title" style={{textAlign:'center'}}>
                Loading Data
                <br/> 
                { fetching ? 'This can take up to 30 seconds' : null } 
            </span>
        </div>
}


export default App
